import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={20} cy={20} r={20} fill="#000" fillOpacity={0.02} />
      <Path
        d="M22.707 19.733v-3.24a.647.647 0 00-.667-.666.647.647 0 00-.667.666v3.5c0 .09.016.173.047.25a.78.78 0 00.14.224l2.8 2.866a.617.617 0 00.487.2.683.683 0 00.486-.2.652.652 0 00.194-.48.652.652 0 00-.194-.48l-2.626-2.64zM22 28a7.757 7.757 0 01-3.107-.63 8.101 8.101 0 01-2.546-1.717 8.101 8.101 0 01-1.717-2.546A7.757 7.757 0 0114 20c0-1.098.21-2.133.63-3.107a8.101 8.101 0 011.717-2.546 8.101 8.101 0 012.546-1.717A7.757 7.757 0 0122 12c1.098 0 2.133.21 3.107.63.973.42 1.822.992 2.546 1.717a8.101 8.101 0 011.717 2.546c.42.974.63 2.01.63 3.107 0 1.098-.21 2.133-.63 3.107a8.101 8.101 0 01-1.717 2.546 8.101 8.101 0 01-2.546 1.717c-.974.42-2.01.63-3.107.63zm0-1.333c1.836 0 3.406-.652 4.71-1.957 1.305-1.304 1.957-2.874 1.957-4.71 0-1.836-.652-3.406-1.957-4.71-1.304-1.304-2.874-1.957-4.71-1.957-1.836 0-3.406.652-4.71 1.957-1.304 1.304-1.957 2.874-1.957 4.71 0 1.836.652 3.406 1.957 4.71 1.304 1.305 2.874 1.957 4.71 1.957z"
        fill="#141414"
      />
      <Circle
        cx={14}
        cy={20}
        r={5.25}
        fill="#FF2E00"
        stroke="#FAFAFA"
        strokeWidth={1.5}
      />
      <Path
        d="M14.028 21.559c-.264 0-.477-.172-.502-.436-.032-.305-.045-.616-.06-.921-.045-.737-.093-1.472-.13-2.209-.017-.305.088-.56.361-.721a.678.678 0 011.014.52c.029.319-.019.633-.035.948-.038.756-.101 1.513-.12 2.27-.016.326-.226.549-.528.549zM14.69 22.744a.678.678 0 01-.68.664.692.692 0 01-.676-.686.695.695 0 01.696-.684c.375.003.664.312.66.706z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
